// Batch 1: New Cairo, Mokattam & South Cairo (35 Areas)
export const areaContentBatch1 = {
  "التجمع الخامس": {
    tier: 1,
    title: "ونش انقاذ التجمع الخامس",
    metaDescription: "ونش انقاذ التجمع الخامس يصلك خلال 8-12 دقيقة: شارع التسعين، كايرو فستيفال، المستثمرين، الجامعة الأمريكية، اللوتس، النرجس. سطحة هيدروليك 24/7 بخصم 50% - اتصل 01044844492.",
    intro: "أوناش ونش إنقاذ محمد بحر متمركزة بصورة دائمة على محور التسعين الشمالي والجنوبي وبالقرب من كايرو فستيفال سيتي ومحور محمد نجيب وميدان ووتر واي، لنصلك في غضون 8 إلى 12 دقيقة داخل أي حي أو كمبوند بالتجمع الخامس على مدار 24 ساعة بأحدث أسطول سطحات هيدروليكية كاملة.",
    responseTime: "8–12 دقيقة في التجمع الخامس",
    dispatchPoints: [
      "محور التسعين الشمالي والجنوبي وتقاطع محمد نجيب (الاستجابة: 8–10 دقائق)",
      "محيط كايرو فستيفال سيتي وداون تاون مول (الاستجابة: 7–9 دقائق)",
      "محيط الجامعة الأمريكية AUC وحي اللوتس والمستثمرين (الاستجابة: 10–12 دقيقة)",
      "الدائري الأوسطي ومحور جمال عبد الناصر (الاستجابة: 10–12 دقيقة)"
    ],
    landmarks: [
      "كايرو فستيفال سيتي مول CFC",
      "الجامعة الأمريكية AUC",
      "كونكورد بلازا والتسعين الجنوبي",
      "ووتر واي The Waterway",
      "مستشفى الدفاع الجوي التخصصي",
      "مستشفى شفا التخصصي بالتجمع",
      "مجمع بنوك شارع التسعين",
      "ميدان مسجد الشرطة",
      "بوينت 90 مول Point 90",
      "مكسيم مول وحي القرنفل"
    ],
    streets: [
      "شارع التسعين الشمالي",
      "شارع التسعين الجنوبي",
      "محور محمد نجيب",
      "محور جمال عبد الناصر",
      "محور طلعت حرب",
      "محور الجزيرة",
      "محور العبور",
      "طريق العين السخنة القديم والجديد",
      "الدائري الأوسطي بالتجمع"
    ],
    localNotes: [
      "أوناش سطحة هيدروليكية كاملة بزاوية نزول صفرية مخصصة للنزول إلى جراجات المولات والكمبوندات السفلية (أقل من 2.1 م) دون أي احتكاك للصدادات أو العتب.",
      "تأمين ونقل سيارات الدفع الرباعي 4x4 والسيارات الفارهة والكهربائية (EV) بحوامل عجل خاصة لحماية الفتيس ونظام التعليق الهوائي (Air Suspension).",
      "بروتوكول دخول فوري للكمبوندات السكنية (قطامية هايتس، ميفيدا، هايد بارك، ماونتن فيو، ستون ريزيدنس) بتنسيق سريع مع أمن البوابات.",
      "إمكانية نقل السيارة مباشرة إلى التوكيلات ومراكز الصيانة المعتمدة بالقاهرة الجديدة أو إلى مجمع صقر قريش والحرفيين.",
      "طاقم مجهز للتعامل الفوري مع نوم البطارية وثقوب الإطارات وتزويد الوقود في الموقع دون الحاجة لرفع السيارة إذا كان العطل بسيطاً."
    ],
    faqs: [
      {
        "q": "كم دقيقة يستغرق وصول الونش في شارع التسعين بالتجمع الخامس؟",
        "a": "يصلك الونش خلال 8 إلى 10 دقائق في معظم الأوقات لتمركزنا الدائم عند تقاطع التسعين مع محور محمد نجيب وأمام كايرو فستيفال سيتي."
      },
      {
        "q": "هل يستطيع الونش النزول إلى جراجات البدروم في مولات وكمبوندات التجمع الخامس؟",
        "a": "نعم، نوفر أوناشاً مدمجة بارتفاع خاص وسطحات نزول زاوية صفرية مجهزة للنزول تحت الأرض (أقل من 2.1 متر) وسحب السيارات المعطلة بأمان تام دون خدش الصدام."
      },
      {
        "q": "كيف يتم التعامل مع سيارات الدفع الرباعي والسيارات الكهربائية (EV) في التجمع؟",
        "a": "نستخدم سطحات هيدروليكية كاملة مزودة بدوليات عجل (Dollies) لرفع العجلات الأربع بالكامل عن الأرض، مما يحمي الفتيس الأوتوماتيكي والبطاريات وأنظمة التعليق الهوائية من أي ضرر."
      },
      {
        "q": "هل أسعار ونش إنقاذ التجمع الخامس محددة ومعلنة مسبقاً؟",
        "a": "نعم، يتم الاتفاق على السعر التقديري الشامل هاتفياً قبل تحرك الونش مباشرة مع تطبيق خصم 50% المعلن وبدون أي إكراميات أو رسوم إضافية مفاجئة."
      },
      {
        "q": "هل تقدمون خدمات شحن البطارية وتغيير الإطارات في موقع السيارة بالتجمع؟",
        "a": "نعم، نمتلك سيارات خدمة متنقلة مزودة بأجهزة شحن بطاريات ذكية وكابلات نحاسية معزولة وضواغط هواء ومعدات تغيير إطارات لإنقاذك في مكانك دون الحاجة لرفع السيارة."
      }
    ],
    nearby: ["شارع التسعين", "التجمع الاول", "التجمع الثالث", "الرحاب", "مدينتي", "الهضبة الوسطى", "المقطم"]
  },

  "التجمع الاول": {
    tier: 2,
    title: "ونش انقاذ التجمع الأول",
    metaDescription: "ونش انقاذ التجمع الأول: حي البنفسج، الياسمين، القرنفل، محور السادات، السوق الشرقي. وصول 10-15 دقيقة بخصم 50% - اتصل الآن 01044844492.",
    intro: "خدمة ونش إنقاذ وسحب سيارات سريعة في التجمع الأول، نغطي أحياء الياسمين والبنفسج والمجاورات السكنية ومحيط أكاديمية الشرطة ومحور السادات على مدار الساعة.",
    responseTime: "10–15 دقيقة في التجمع الأول",
    landmarks: ["أكاديمية الشرطة", "السوق الشرقي", "ميدان مسجد حسن الشربتلي", "محور السادات", "منطقة خدمات البنفسج"],
    streets: ["محور السادات", "شارع أحمد شوقي", "شارع التسعين الشمالي (مدخل الأول)", "محور مصطفى كامل", "شارع الياسمين"],
    localNotes: ["تمركز بالقرب من أكاديمية الشرطة وميدان الرحاب للوصول السريع للأحياء الداخلية.", "أوناش مجهزة للتعامل مع سيارات الدفع الرباعي والسيارات الفارهة بدون أي خدوش."],
    faqs: [
      {
            "q": "هل تغطون حي الياسمين والبنفسج بالتجمع الأول؟",
            "a": "نعم، تغطية كاملة للياسمين والبنفسج والقرنفل وسوان ليك خلال 10 إلى 15 دقيقة."
      }
,
      {
        "q": "هل تغطون الكمبوندات على طريق التجمع الأول والدائري؟",
        "a": "نعم، كمبوندات التجمع الأول من طريق السويس حتى الدائري وعلى الطريق الرئيسي كلها مغطاة."
      }],
    nearby: ["التجمع الخامس", "الرحاب", "شارع التسعين", "مدينة نصر", "طريق السويس"]
  },

  "التجمع الثالث": {
    tier: 2,
    title: "ونش انقاذ التجمع الثالث",
    metaDescription: "ونش انقاذ التجمع الثالث: المحلية الثالثة، الشباب، الأندلس، الجامعة الألمانية GUC، فيوتشر مول. وصول 10-15 دقيقة خدمة 24 ساعة - 01044844492.",
    intro: "خدمة ونش إنقاذ سريعة في التجمع الثالث تغطي محيط الجامعة الألمانية GUC، إسكان الشباب، حي الأندلس، وفيوتشر مول ومحور جمال عبد الناصر في أقل من 15 دقيقة.",
    responseTime: "10–15 دقيقة في التجمع الثالث",
    landmarks: ["الجامعة الألمانية بالقاهرة GUC", "فيوتشر مول", "ميدان أرابيلا", "سوق الحرفيين بالتجمع الثالث", "محطة الغاز الطبيعي"],
    streets: ["محور جمال عبد الناصر", "شارع الشباب", "محور محمد نجيب", "شارع النرجس", "طريق القطامية القديم"],
    localNotes: ["أوناش مجهزة للتعامل مع المنحدرات والمرتفعات الحادة في التجمع الثالث ومداخل القطامية.", "تغطية مخصصة لحالات تعطل الطلاب والموظفين في محيط الجامعة الألمانية GUC وميدان أرابيلا بلازا.", "جاهزية تامة لسحب السيارات ونقلها لمراكز الصيانة وميكانيكا التجمع أو الحرفيين وصقر قريش."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ للجامعة الألمانية GUC؟",
            "a": "يصلك الونش في أقل من 10 دقائق من نقطة تمركزنا عند مدخل أرابيلا ومحور جمال عبد الناصر."
      },
      {
            "q": "هل تقدمون خدمات شحن البطارية في التجمع الثالث؟",
            "a": "نعم، نوفر أجهزة شحن وبطاريات طوارئ بديلة لتشغيل السيارة فوراً في مكانك."
      }
],
    nearby: ["التجمع الخامس", "القطامية", "الهضبة الوسطى", "طريق العين السخنة", "المعادي"]
  },

  "شارع التسعين": {
    tier: 2,
    title: "ونش انقاذ شارع التسعين التجمع الخامس",
    metaDescription: "ونش انقاذ شارع التسعين الشمالي والجنوبي: وصول فوري 10 دقائق لكافة الميادين والمراكز التجارية والشركات. خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "شارع التسعين هو الشريان التجاري والحيوي الأول بالقاهرة الجديدة. نوفر أوناش إنقاذ متمركزة عند تقاطعات التسعين الشمالي والجنوبي مع محاور نجيب والأمل لإنقاذ سريع خلال دقائق.",
    responseTime: "10 دقائق على شارع التسعين",
    landmarks: ["كايرو فستيفال سيتي", "ووتر واي The Waterway", "كونكورد بلازا", "مجمع البنوك بالتسعين", "مستشفى التجمع الخامس العام", "ميدان نادي بتروسبورت"],
    streets: ["شارع التسعين الشمالي", "شارع التسعين الجنوبي", "محور العروبة", "محور محمد نجيب", "محور الأمل"],
    localNotes: ["تأمين فوري لموقع السيارة على التسعين لمنع التكدس المروري.", "توفير سطحات هيدروليكية بالكامل لنقل السيارات الرياضية والكهربائية الفاخرة."],
    faqs: [
      {
            "q": "هل توفرون ونش عند مول ووتر واي بالتسعين الشمالي؟",
            "a": "نعم، لدينا ونش متمركز بصفة دائمة بالقرب من ووتر واي والتسعين الشمالي."
      }
,
      {
        "q": "ما أسرع وقت وصول على شارع التسعين الجنوبي وقت ذروة العودة؟",
        "a": "متوسط وصولنا على شارع التسعين 10-15 دقيقة، ولدينا أوناش تنتظر عند مخرج التجمع من الدائري."
      }],
    nearby: ["التجمع الخامس", "التجمع الاول", "الرحاب", "طريق السويس", "طريق العين السخنة"]
  },

  "الرحاب": {
    tier: 1,
    title: "ونش انقاذ الرحاب",
    metaDescription: "ونش انقاذ الرحاب وبوابات 1 إلى 24: مول الرحاب 1 و 2، السوق الشرقي، طريق السويس. وصول 10-15 دقيقة خدمة 24 ساعة بخصم 50% - اتصل 01044844492.",
    intro: "مدينة الرحاب أول مدينة سكنية متكاملة بشرق القاهرة. أوناشنا متمركزة عند بوابات الرحاب الرئيسية على طريق السويس ومحور طلعت مصطفى لدخول سريع لكافة المجموعات والمراكز التجارية.",
    responseTime: "10–15 دقيقة داخل الرحاب",
    landmarks: ["السوق الشرقي بالرحاب", "مول الرحاب 1 و 2", "بوابة الرحاب 6 (طريق السويس)", "بوابة 13 و 19", "مجمع البنوك والمطاعم بالرحاب", "نادي الرحاب الرياضي"],
    streets: ["طريق السويس", "محور طلعت مصطفى", "شارع أحمد شوقي", "طريق الرحاب - مدينتي", "طريق السباعي"],
    localNotes: ["تنسيق فوري مع أمن بوابات الرحاب لسرعة الدخول دون تعطيل العميل.", "أوناش مدمجة تتحرك بسلاسة داخل الشوارع السكنية والمجموعات الضيقة بالرحاب."],
    faqs: [
      {
            "q": "كيف يدخل الونش من بوابات مدينة الرحاب؟",
            "a": "يقوم سائق الونش بإبراز تصريح المهمة والتنسيق مع أمن البوابة برقم العميل والدخول مباشرة."
      }
,
      {
        "q": "هل تغطون حوادث الأعطال داخل مولات الرحاب وجراجاتها؟",
        "a": "نعم، نتعامل مع حالات أعطال الجراجات المتعددة الطوابق داخل الرحاب بأوناش مدمجة تناسب الممرات الضيقة."
      }],
    nearby: ["مدينتي", "التجمع الاول", "التجمع الخامس", "طريق السويس", "الشروق"]
  },

  "مدينتي": {
    tier: 1,
    title: "ونش انقاذ مدينتي",
    metaDescription: "ونش انقاذ مدينتي: بوابات 1 إلى 6، أوبن إير مول، الساوث بارك، الكرافت زون. وصول 15-20 دقيقة خدمة 24 ساعة بخصم 50% - اتصل 01044844492.",
    intro: "مدينتي أكبر مجمع سكني مغلق في شرق القاهرة. أوناش إنقاذ محمد بحر متمركزة بالقرب من بوابات مدينتي على طريق السويس والدائري الإقليمي والأوسطي لخدمة سريعة لكافة المراحل والأنشطة التجارية.",
    responseTime: "15–20 دقيقة داخل مدينتي",
    landmarks: ["أوبن إير مول Open Air Mall", "ساوث بارك South Park", "كرافت زون Craft Zone", "نادي مدينتي الرياضي", "بوابة 1 مدينتي (طريق السويس)", "بوابة 2 مدينتي", "بوابة 4 و 5"],
    streets: ["طريق السويس الصحراوي", "الدائري الأوسطي", "محور الأمل", "دائري مدينتي الداخلي", "شارع الشانزليزيه مدينتي"],
    localNotes: ["تنسيق مسبق عند بوابات 1 و 2 و 4 لدخول شاحنات السحب دون انتظار.", "خدمة فورية لأعطال مواقف الأوبن إير مول والسنترالات ومناطق الفيلات B1 إلى B12."],
    faqs: [
      {
            "q": "هل يمكن لونش إنقاذ الدخول إلى مراحل الفيلات في مدينتي؟",
            "a": "نعم، نصل إلى أي مرحلة عمارات أو فيلات في مدينتي فور تأكيد رقم البوابة مع العميل."
      }
,
      {
        "q": "كيف يتم التنسيق لدخول الونش إلى مجمع مدينتي المغلق؟",
        "a": "يكفي أن تتصل بنا أولاً وتخبرنا رقم البوابة، ثم ندير التنسيق مع إدارة الكمبوند لإنجاز الدخول بسرعة."
      }],
    nearby: ["الرحاب", "الشروق", "بدر", "العاصمة الإدارية", "طريق السويس"]
  },

  "الشروق": {
    tier: 1,
    title: "ونش انقاذ الشروق",
    metaDescription: "ونش انقاذ مدينة الشروق: مداخل طريق السويس وطريق الإسماعيلية، حي الأندلس، الجامعة البريطانية BUE، بانوراما مول. وصول 15-20 دقيقة - 01044844492.",
    intro: "مدينة الشروق حلقة الوصل بين طريقي السويس والإسماعيلية. نوفر أوناش إنقاذ متمركزة عند مدخل الشروق 1 و 2 ومحيط الجامعة البريطانية لخدمة الأحياء السكنية والجامعات والنوادي.",
    responseTime: "15–20 دقيقة في الشروق",
    landmarks: ["الجامعة البريطانية في مصر BUE", "الجامعة الفرنسية", "مول تاون سنتر الشروق", "نادي الشروق الرياضي", "ميدان النهضة", "بوابة الشروق 1 و 2"],
    streets: ["طريق السويس الصحراوي", "طريق الإسماعيلية الصحراوي", "محور الشباب الشروق", "شارع النادي", "محور جمال عبد الناصر الشروق"],
    localNotes: ["تغطية كاملة للمداخل الرابطة بين طريق السويس وطريق الإسماعيلية ومحيط هليوبوليس الجديدة.", "تجهيزات إنقاذ حديثة لسحب السيارات العالقة في الرمال أو جوانب الطرق غير الممهدة."],
    faqs: [
      {
            "q": "هل تغطون الجامعة البريطانية BUE ونادي هليوبوليس بالشروق؟",
            "a": "نعم، لدينا أوناش متمركزة عند محور الشباب بالقرب من الجامعات والنوادي."
      }
,
      {
        "q": "ما زمن الوصول من مدينة الشروق إلى القاهرة الجديدة أو طريق السويس؟",
        "a": "للعمل داخل الشروق: 15-25 دقيقة. لنقل السيارة إلى التجمع أو الحرفيين: إضافة 15-30 دقيقة."
      }],
    nearby: ["مدينتي", "بدر", "مدينة المستقبل", "العاصمة الإدارية", "العبور", "طريق السويس"]
  },

  "بدر": {
    tier: 2,
    title: "ونش انقاذ مدينة بدر",
    metaDescription: "ونش انقاذ مدينة بدر: طريق السويس، المنطقة الصناعية، محطة القطار الخفيف LRT، الروبيكي، جامعة بدر BUC. وصول 15-20 دقيقة - 01044844492.",
    intro: "خدمة ونش إنقاذ متكاملة في مدينة بدر، نغطي جامعة بدر (BUC)، مدينة الجلود بالروبيكي، المنطقة الصناعية، ومحطات القطار الكهربائي الخفيف (LRT) على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة في مدينة بدر",
    landmarks: ["جامعة بدر BUC", "الجامعة الروسية ERU", "مدينة الجلود بالروبيكي", "محطة قطار LRT بدر", "المنطقة الصناعية بمدينة بدر"],
    streets: ["طريق القاهرة - السويس الصحراوي", "طريق الروبيكي", "طريق الإسماعيلية - بدر", "محور سعد زغلول", "شارع الجامعة"],
    localNotes: ["أوناش ثقيلة وسطحات جاهزة لنقل سيارات النقل والمعدات وسيارات الموظفين بالمنطقة الصناعية.", "تغطية شاملة لطريق الروبيكي ومداخل العاصمة الإدارية الشمالية."],
    faqs: [
      {
            "q": "هل توفرون ونش سحب للسيارات المتعطلة على طريق الروبيكي بمدينة بدر؟",
            "a": "نعم، نغطي طريق الروبيكي بالكامل ومنطقة المصانع حتى طريق الإسماعيلية."
      }
,
      {
        "q": "هل تخدمون مدينة بدر وكمبوندات المجاورة لطريق السويس؟",
        "a": "نعم، مدينة بدر كاملة مغطاة بالإضافة لامتداد طريق السويس من بداية القاهرة الجديدة حتى مدخل بدر."
      }],
    nearby: ["الشروق", "العاصمة الإدارية", "العاشر من رمضان", "طريق السويس", "مدينتي"]
  },

  "مدينة المستقبل": {
    tier: 2,
    title: "ونش انقاذ مدينة المستقبل",
    metaDescription: "ونش انقاذ مدينة المستقبل (مستقبل سيتي): طريق السويس، طريق الأمل، كمبوندات البوسكو ومونتي نابليوني. وصول 15-20 دقيقة بخصم 50% - 01044844492.",
    intro: "تغطية متخصصة لإنقاذ السيارات في مدينة المستقبل (Mostakbal City) على طريق السويس ومحور الأمل، لخدمة سكان ورواد كافة الكمبوندات والمشروعات السكنية الجديدة بسرعة وأمان.",
    responseTime: "15–20 دقيقة في مدينة المستقبل",
    landmarks: ["بوابة مستقبل سيتي Mostakbal City", "كمبوند البوسكو سيتي", "كمبوند مونتي نابليوني", "كمبوند بلوم فيلدز", "محور الأمل"],
    streets: ["محور الأمل", "طريق القاهرة السويس", "الدائري الأوسطي", "طريق المستقبل - مدينتي"],
    localNotes: ["أوناش سطحة مجهزة لنقل السيارات الفارهة بدون احتكاك بالأرضيات أو المطبات الحديثة.", "تنسيق فوري للدخول عبر بوابات مشروعات مستقبل سيتي."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ لكمبوندات مدينة المستقبل؟",
            "a": "يصل الونش خلال 15 إلى 20 دقيقة من نقطة تمركزنا على مخرج الدائري الأوسطي ومحور الأمل."
      }
,
      {
        "q": "كم تكلفة نقل سيارة من مدينة المستقبل إلى القاهرة؟",
        "a": "التكلفة تحدد حسب المسافة الدقيقة ونوع السيارة. اتصل على 01044844492 للحصول على سعر فوري وثابت بلا مفاجآت."
      }],
    nearby: ["مدينتي", "الشروق", "العاصمة الإدارية", "التجمع الخامس", "طريق السويس"]
  },

  "العاصمة الإدارية": {
    tier: 1,
    title: "ونش انقاذ العاصمة الإدارية الجديدة",
    metaDescription: "ونش انقاذ العاصمة الإدارية: الحي الحكومي، البرج الأيقوني، الحي المالي، R3 و R7، محور بن زايد. وصول 15-20 دقيقة خدمة 24 ساعة - 01044844492.",
    intro: "العاصمة الإدارية الجديدة صرح مصر المستقبلي. ننشر أسطول ونش إنقاذ حديث على محاور محمد بن زايد الشمالي والجنوبي والطريق الدائري الإقليمي لخدمة الحي الحكومي والحي المالي وكافة الأحياء السكنية (R1 إلى R8).",
    responseTime: "15–20 دقيقة في العاصمة الإدارية",
    landmarks: ["البرج الأيقوني Iconic Tower", "الحي الحكومي ومجلس الوزراء", "الحي المالي والبنك المركزي", "حي المال والأعمال", "مسجد مصر الكبير", "فندق الماسة", "أحياء R3 و R7 و R8"],
    streets: ["محور محمد بن زايد الشمالي", "محور محمد بن زايد الجنوبي", "الدائري الإقليمي", "الدائري الأوسطي", "محور الأمل", "طريق السخنة - العاصمة"],
    localNotes: ["تصاريح دخول رسمية للحي الحكومي وحي الوزارات والمواقع الإنشائية الكبرى.", "أوناش هيدروليكية كاملة السطحة لنقل السيارات الحديثة والكهربائية (EVs) بأمان تام."],
    faqs: [
      {
            "q": "هل تغطون الحي الحكومي والبرج الأيقوني بالعاصمة الإدارية؟",
            "a": "نعم، أوناشنا متمركزة على محور بن زايد الشمالي لخدمة البرج الأيقوني والحي المالي والحكومي فوراً."
      }
,
      {
        "q": "هل لديكم تغطية دائمة داخل حرم العاصمة الإدارية الجديدة؟",
        "a": "نعم، نغطي العاصمة الإدارية وطريق الكباش والمنطقة الحكومية وكمبوندات المسكن بالتنسيق مع الجهات الأمنية."
      }],
    nearby: ["التجمع الخامس", "مدينتي", "بدر", "الشروق", "طريق السخنة", "طريق السويس"]
  },

  "المقطم": {
    tier: 1,
    title: "ونش انقاذ المقطم",
    metaDescription: "ونش انقاذ المقطم: شارع 9، ميدان النافورة، كورنيش المقطم، الهضبة الوسطى والعليا. ونش مجهز للمنحدرات والمرتفعات وصول 10-15 دقيقة - 01044844492.",
    intro: "ونش إنقاذ المقطم والهضبة الوسطى وميدان النافورة ومطلع السلاب؛ أوناش مجهزة للتعامل مع المنحدرات الحادة وطبيعة المقطم الجبلية في 10 إلى 15 دقيقة.",
    responseTime: "10–15 دقيقة في المقطم",
    landmarks: ["ميدان النافورة بالمقطم", "شارع 9 التجاري", "كورنيش المقطم", "نادي المقطم الرياضي", "مطلع المقطم من صلاح سالم", "مجمع بنوك شارع 9"],
    streets: ["شارع 9", "شارع صبحي حسين", "شارع 17", "طريق الأوتوستراد (مطلع المقطم)", "شارع المقطم الرئيسي", "محور عبد المجيد محمود"],
    localNotes: ["أوناش ذات فرامل هيدروليكية قوية وسلاسل تأمين مخصصة لإنقاذ السيارات على مطالع ومنازل المقطم الشديدة الانحدار.", "التعامل الفوري مع أعطال سخونة الفرامل وتلف الدبرياج الشائعة في صعود المقطم من صلاح سالم أو الأوتوستراد.", "تغطية سريعة لكمبوندات الهضبة الوسطى ونادي الصيد ومحيط كارفور المعادي القريب."],
    faqs: [
      {
            "q": "لو تعطلت فرامل السيارة على مطلع المقطم كيف يتم سحبها؟",
            "a": "نثبت السيارة فوراً بدعامات أمان ونرفعها بالكامل على سطحة هيدروليكية لتفادي انزلاقها على المنحدر."
      },
      {
            "q": "كم يستغرق الونش للوصول إلى ميدان النافورة أو شارع 9 بالمقطم؟",
            "a": "من 10 إلى 12 دقيقة لتواجد ونش متمركز دائماً بالقرب من ميدان النافورة ومحور الشهيد."
      }
],
    nearby: ["الهضبة الوسطى", "المعادي", "صلاح سالم", "مدينة نصر", "الأوتوستراد", "السيدة زينب"]
  },

  "الهضبة الوسطى": {
    tier: 2,
    title: "ونش انقاذ الهضبة الوسطى المقطم",
    metaDescription: "ونش انقاذ الهضبة الوسطى: الجامعة الحديثة MTI، شارع الجامعة، كارفور المعادي، الطريق الدائري. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "تغطية شاملة لإنقاذ وسحب السيارات في الهضبة الوسطى بالمقطم ومحيط الجامعة الحديثة للتكنولوجيا والمعلومات (MTI)، الحي الأول حتى الحي الثامن، ومخرج الطريق الدائري عند كارفور المعادي.",
    responseTime: "10–15 دقيقة في الهضبة الوسطى",
    landmarks: ["الجامعة الحديثة MTI", "نادي إيزي سبورتس Easy Sports", "مستشفى كليوباترا المقطم", "مجمع كارفور المعادي الدائري", "مدرسة ريماس"],
    streets: ["شارع الجامعة الحديثة", "محور الشهيد", "طريق كارفور المعادي - الهضبة", "شارع صبحي حسين (مدخل الهضبة)", "شارع مدرسة ريماس"],
    localNotes: ["تمركز استراتيجي بين نزلة الدائري ومدخل المقطم لسرعة الوصول لأحياء الهضبة السبعة.", "جاهزية كاملة للتعامل مع بطاريات السيارات وإطاراتها في الموقع."],
    faqs: [
      {
            "q": "هل تخدمون محيط الجامعة الحديثة MTI ونادي إيزي سبورتس؟",
            "a": "نعم، نصل إلى الجامعة الحديثة ونادي إيزي سبورتس في أقل من 10 دقائق."
      }
,
      {
        "q": "هل تصلون لمناطق الهضبة الوسطى وطريق الكيلو 4.5؟",
        "a": "نعم، نغطي الهضبة الوسطى بالكامل من مدخل الدائري حتى ميدان الكيلو 4.5 وطريق الكورنيش."
      }],
    nearby: ["المقطم", "المعادي", "كارفور المعادي", "القطامية", "الطريق الدائري", "الأوتوستراد"]
  },

  "المعادي": {
    tier: 1,
    title: "ونش انقاذ المعادي",
    metaDescription: "ونش انقاذ المعادي: شارع 9، دجلة، الكورنيش، ثكنات المعادي، المعادي الجديدة. ونش سريع 10-15 دقيقة خدمة 24 ساعة بخصم 50% - اتصل 01044844492.",
    intro: "أوناش ونش إنقاذ محمد بحر منتشرة في قلب المعادي: من كورنيش النيل وشارع 9 حتى دجلة وثكنات المعادي والمعادي الجديدة، بمتوسط وصول 10 دقائق فقط.",
    responseTime: "10 دقائق في المعادي",
    landmarks: ["كورنيش النيل بالمعادي", "شارع 9 التجاري", "ميدان الجزائر وميدان فونتانا", "محطة مترو ثكنات المعادي", "جراند مول المعادي", "نادي وادي دجلة المعادي"],
    streets: ["شارع 9", "شارع النصر (المعادي الجديدة)", "شارع دجلة 250", "شارع اللاسلكي", "كورنيش النيل", "طريق مصر حلوان الزراعي"],
    localNotes: ["أوناشنا تتعامل يومياً مع أعطال كورنيش النيل وزحام شارع 9 وتدخل شوارع دجلة السكنية الهادئة بكل سلاسة.", "القرب المباشر من مجمع صقر قريش (5 دقائق) يمنحك سرعة فائقة لنقل السيارة لأفضل ورش الميكانيكا والعفشة.", "تأمين كامل للسيارات الفارهة وسيارات الدفع الرباعي 4x4 أثناء الرفع والنقل بسطحات هيدروليكية كاملة."],
    faqs: [
      {
            "q": "هل يصل الونش لكورنيش المعادي وقت الذروة؟",
            "a": "نعم، لدينا تمركز دائم على كورنيش المعادي بالقرب من مستشفى القوات المسلحة ومطلع الدائري للوصول الفوري."
      },
      {
            "q": "كم تكلفة سحب سيارة من المعادي إلى صقر قريش؟",
            "a": "التكلفة تبدأ من 250 ج.م شاملة التحميل والتأمين مع تطبيق خصم الـ 50% المعلن."
      }
],
    nearby: ["زهراء المعادي", "صقر قريش", "الأوتوستراد", "دار السلام", "حلوان", "البساتين", "المقطم"]
  },

  "زهراء المعادي": {
    tier: 2,
    title: "ونش انقاذ زهراء المعادي",
    metaDescription: "ونش انقاذ زهراء المعادي: كارفور المعادي، شارع الخمسين، كوبري الزهراء، مدخل طريق السخنة. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "ونش إنقاذ زهراء المعادي والشطر العاشر ومحيط كارفور المعادي ووادي دجلة؛ أوناش سريعة تصلك في 10 إلى 15 دقيقة لإنقاذ وسحب سيارتك بأمان تام.",
    responseTime: "10–15 دقيقة في زهراء المعادي",
    landmarks: ["كارفور المعادي City Centre", "شارع الخمسين الرئيسي", "مسجد الكويتي", "ميدان فودافون بالزهراء", "كوبري زهراء المعادي"],
    streets: ["شارع الخمسين", "طريق الزهراء الرئيسي", "طريق القطامية - السخنة", "شارع النادي الكويتي", "امتداد شارع النصر"],
    localNotes: ["تمركز مباشر بالقرب من كارفور المعادي ومطلع الأوتوستراد لسرعة الوصول لكافة أشطر الزهراء.", "أوناش مجهزة لتفادي احتكاك صدادات السيارات بالمطبات العالية المنتشرة بشوارع الزهراء الداخلية.", "نقل سريع لسيارات الأعطال إلى مجمع صقر قريش أو مراكز صيانة طريق السخنة والدائري."],
    faqs: [
      {
            "q": "هل يصل الونش لمحيط كارفور المعادي والشطر العاشر سريعاً؟",
            "a": "نعم، نصلك في أقل من 10 دقائق لتواجد ونش متمركز دائماً عند مدخل الزهراء من الأوتوستراد."
      },
      {
            "q": "لو البطارية نامت في جراج بالزهراء هل توفرون شحن؟",
            "a": "نعم، نوفر فني بكابلات شحن احترافية لتشغيل بطارية سيارتك فوراً في مكانك."
      }
],
    nearby: ["المعادي", "صقر قريش", "الأوتوستراد", "القطامية", "الهضبة الوسطى", "طريق السخنة"]
  },

  "صقر قريش": {
    tier: 2,
    title: "ونش انقاذ صقر قريش",
    metaDescription: "ونش انقاذ صقر قريش: موقف صقر قريش، مجمع الورش ومراكز الصيانة، عمارات صقر قريش، شارع النصر. وصول 10 دقائق خدمة 24/7 بخصم 50% - 01044844492.",
    intro: "خدمة ونش إنقاذ فورية في صقر قريش؛ المركز الأكبر لصيانة وعمرة السيارات بجنوب القاهرة؛ نصلك خلال 5 إلى 10 دقائق لسحب سيارتك ونقلها لأي ورشة متخصصة.",
    responseTime: "5–10 دقائق في صقر قريش",
    landmarks: ["موقف صقر قريش الرئيسي", "مجمع ورش ومراكز صيانة صقر قريش", "تقاطع الأوتوستراد مع الدائري", "عمارات صقر قريش"],
    streets: ["طريق الأوتوستراد", "نزلة صقر قريش", "شارع النصر صقر قريش", "شارع صقر قريش الداخلي"],
    localNotes: ["معرفة دقيقة بأماكن ورش الميكانيكا، الفتيس الأوتوماتيك، الشكمانات، والعفشة بمجمع صقر قريش.", "تمركز مباشر على مطلع الأوتوستراد والدائري لنجدة السيارات القادمة من المعادي والمقطم وحلوان.", "أوناش شوكة وسحب مجهزة للمناورة والتنزيل داخل حارات وورش صقر قريش المزدحمة."],
    faqs: [
      {
            "q": "هل تساعدون في اختيار ورشة صيانة موثوقة في صقر قريش؟",
            "a": "سائقونا بحكم خبرتهم اليومية يرشدونك لأفضل الورش المتخصصة في نوع سيارتك وعطلها بدقة."
      },
      {
            "q": "كم يستغرق وصول الونش لو تعطلت على كوبري صقر قريش بالأوتوستراد؟",
            "a": "نصلك في أقل من 7 دقائق لأن صقر قريش من نقاط تمركزنا الثابتة على مدار 24 ساعة."
      }
],
    nearby: ["المعادي", "زهراء المعادي", "الأوتوستراد", "البساتين", "الدائري", "المقطم"]
  },

  "الأوتوستراد": {
    tier: 2,
    title: "ونش انقاذ الأوتوستراد",
    metaDescription: "ونش انقاذ الأوتوستراد: كوبري طنطاوي، محور المشير، محور الشهيد، طرة، ومطلع الهضبة. ونش سريع 10-15 دقيقة على مدار 24 ساعة - 01044844492.",
    intro: "خدمة ونش إنقاذ سريعة على طريق الأوتوستراد من مدينة نصر والقلعة حتى طرة والمعادي وشق الثعبان وحلوان؛ استجابة فورية 24 ساعة بخصم 50%.",
    responseTime: "10–15 دقيقة على الأوتوستراد",
    landmarks: ["كوبري طنطاوي ومحور المشير", "نزلة الأوتوستراد من المقطم", "تقاطع الأوتوستراد مع الدائري", "سجن طرة القديم", "ميدان رمسيس الأوتوستراد"],
    streets: ["طريق الأوتوستراد الرئيسي", "محور المشير طنطاوي", "محور الشهيد", "امتداد رمسيس الأوتوستراد", "طريق الأوتوستراد المعادي"],
    localNotes: ["تأمين ونقل سيارات الملاكي وسيارات النقل العالقة على مسارات الأوتوستراد السريعة.", "تمركزات مباشرة عند مطلع دائري المعادي، شق الثعبان، ونفق طرة لسرعة التدخل وتفادي الحوادث.", "نقل مباشر إلى مجمع ورش صقر قريش الواقع مباشرة على الأوتوستراد لأي إصلاحات ميكانيكية."],
    faqs: [
      {
            "q": "هل تغطون منطقة شق الثعبان وطرة على الأوتوستراد؟",
            "a": "نعم، قطاع شق الثعبان وطرة وحلوان مغطى بأوناش سطحة وروافع ثقيلة على مدار الساعة."
      },
      {
            "q": "كم تكلفة سحب سيارة معطلة على الأوتوستراد إلى صقر قريش؟",
            "a": "التسعيرة تبدأ من 250 ج.م ويتم تحديدها بوضوح في المكالمة قبل تحرك الونش."
      }
],
    nearby: ["المعادي", "صقر قريش", "مدينة نصر", "المقطم", "طرة", "حلوان", "البساتين"]
  },

  "القطامية": {
    tier: 2,
    title: "ونش انقاذ القطامية",
    metaDescription: "ونش انقاذ القطامية: القطامية هايتس، طريق السخنة، محمية وادي دجلة، المنطقة الصناعية، جمارك القطامية. وصول 10-15 دقيقة - 01044844492.",
    intro: "خدمة ونش إنقاذ سريعة في القطامية تغطي طريق العين السخنة، معمار المرشدي، جاردينيا، ومحور المشير؛ نصلك خلال 15 دقيقة بأوناش سطحة مجهزة للطرق الجبلية والمنحدرات.",
    responseTime: "15 دقيقة في القطامية",
    landmarks: ["كمبوند القطامية هايتس Katameya Heights", "محمية وادي دجلة", "جمارك سيارات القطامية", "المنطقة الصناعية بالقطامية", "مجمع ون ستريت القطامية"],
    streets: ["طريق القطامية - العين السخنة", "محور محمد نجيب القطامية", "شارع جمال عبد الناصر القطامية", "محور المشير الغربي"],
    localNotes: ["أوناش ذات عزم قوي مجهزة للتعامل مع مرتفعات القطامية ومداخل طريق العين السخنة.", "خدمة متخصصة لسكان كمبوندات وان قطامية والبارون سيتي مع سرعة الدخول عبر البوابات.", "تأمين سريع للسيارات المعطلة على امتداد الطريق الدائري الأوسطي ومحور السخنة."],
    faqs: [
      {
            "q": "كم يستغرق ونش الإنقاذ للوصول إلى وان قطامية أو طريق السخنة؟",
            "a": "يصل الونش خلال 10 إلى 15 دقيقة لتمركزنا بالقرب من كوبري القطامية ومدخل السخنة."
      },
      {
            "q": "هل تقدمون خدمة نقل السيارات من القطامية إلى السخنة أو الجونة؟",
            "a": "نعم، نوفر سطحات سفر مجهزة لنقل السيارات للمدن الساحلية بأمان تام."
      }
],
    nearby: ["التجمع الخامس", "المعادي", "زهراء المعادي", "الهضبة الوسطى", "طريق السخنة"]
  },

  "حلوان": {
    tier: 2,
    title: "ونش انقاذ حلوان",
    metaDescription: "ونش انقاذ حلوان: كورنيش النيل، جامعة حلوان، الحديقة اليابانية، عين حلوان، شارع منصور. وصول 10-15 دقيقة خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "ونش إنقاذ حلوان، ركن فاروق، عين حلوان، والأوتوستراد حتى التبين وطريق الكريمات؛ أوناش سحب وسطحات هيدروليكية تغطي كافة ضواحي حلوان في 15 دقيقة.",
    responseTime: "15 دقيقة في حلوان",
    landmarks: ["جامعة حلوان وعين حلوان", "محطة مترو حلوان", "كورنيش كابريتاج حلوان", "الحديقة اليابانية بحلوان", "مستشفى الإنتاج الحربي بحلوان"],
    streets: ["شارع منصور", "شارع راغب", "شارع عمر بن عبد العزيز", "طريق كورنيش النيل حلوان", "طريق الأوتوستراد حلوان"],
    localNotes: ["تغطية لحالات أعطال الطلاب والموظفين بمحيط جامعة حلوان ومحطات المترو.", "جاهزية كاملة لإنقاذ السيارات على طريق الأوتوستراد السريع وطريق كورنيش حلوان ومدخل الكريمات.", "أوناش ثقيلة مجهزة لنقل سيارات النقل والميكروباص بجانب سيارات الملاكي بأرخص الأسعار."],
    faqs: [
      {
            "q": "هل تغطون منطقة جامعة حلوان وركن فاروق؟",
            "a": "نعم، تغطية شاملة لجامعة حلوان والشارع التجاري وركن فاروق والكورنيش في دقائق معدودة."
      },
      {
            "q": "كم تكلفة نقل سيارة من حلوان إلى القاهرة أو الجيزة؟",
            "a": "نقدم أسعاراً مخفضة مع خصم 50% ويتم الاتفاق على السعر الثابت تليفونياً قبل التحرك."
      }
],
    nearby: ["المعصرة", "طرة", "المعادي", "الأوتوستراد", "15 مايو", "كورنيش حلوان"]
  },

  "المعصرة": {
    tier: 2,
    title: "ونش انقاذ المعصرة",
    metaDescription: "ونش انقاذ المعصرة: كورنيش النيل، محطة مترو المعصرة، الأوتوستراد، حدائق حلوان. وصول 10-15 دقيقة خدمة 24 ساعة - 01044844492.",
    intro: "خدمة ونش إنقاذ وسحب سيارات سريعة في المعصرة بين المعادي وحلوان، تغطي كورنيش النيل وطريق مصر حلوان الزراعي والأوتوستراد والمناطق السكنية والصناعية المحيطة.",
    responseTime: "10–15 دقيقة في المعصرة",
    landmarks: ["محطة مترو المعصرة", "مصنع سيماف ومصانع المعصرة", "ميدان المعصرة الرئيسي", "محطة محولات المعصرة"],
    streets: ["كورنيش النيل - المعصرة", "طريق مصر حلوان الزراعي", "شارع ترعة الخشاب", "امتداد الأوتوستراد المعصرة"],
    localNotes: ["جاهزية للتعامل مع أعطال الطريق الزراعي وكورنيش النيل في أوقات الذروة.", "خدمات طوارئ فورية لتغيير الإطارات وشحن البطاريات على الطريق."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في منطقة المعصرة؟",
            "a": "يصلك الونش خلال 10 إلى 15 دقيقة من أقرب نقطة تمركز على الكورنيش."
      }
,
      {
        "q": "ما زمن وصول الونش من المعصرة إلى المعادي أو حلوان؟",
        "a": "المعصرة قريبة جداً: أوناشنا تصل في 5-15 دقيقة إلى أي موقع داخل المعصرة وحلوان والبساتين."
      }],
    nearby: ["حلوان", "طرة", "المعادي", "كوتسيكا", "الأوتوستراد"]
  },

  "البساتين": {
    tier: 2,
    title: "ونش انقاذ البساتين",
    metaDescription: "ونش انقاذ البساتين: ميدان البساتين، شارع أحمد زكي، الأوتوستراد، الدائري، بير أم سلطان. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "نوفر خدمة ونش إنقاذ سيارات متمرسة في حي البساتين، نغطي شارع أحمد زكي وشارع البساتين العمومي ومحيط نزلة الدائري والأوتوستراد للسيارات الملاكي والتجارية.",
    responseTime: "10–15 دقيقة في البساتين",
    landmarks: ["ميدان البساتين العمومي", "شارع أحمد زكي التجاري", "محكمة البساتين ودار السلام", "نزلة الدائري بالبساتين"],
    streets: ["شارع أحمد زكي", "شارع البساتين العمومي", "شارع فايدة كامل", "طريق الأوتوستراد (قطاع البساتين)", "شارع 306"],
    localNotes: ["أوناش مدمجة قادرة على المناورة في الشوارع التجارية الضيقة والمزدحمة بالبساتين.", "تغطية سريعة لمدخل الأوتوستراد وصقر قريش وكوبري التونسي."],
    faqs: [
      {
            "q": "هل يمكن للونش دخول الشوارع الضيقة في شارع أحمد زكي بالبساتين؟",
            "a": "نعم، أوناشنا من النوع المدمج المخصص للتعامل مع الشوارع السكنية والتجارية الضيقة."
      }
,
      {
        "q": "هل تغطون منطقة البساتين الصناعية وورش سيارات الحوادث؟",
        "a": "نعم، ورش البساتين والمنطقة الصناعية وشارع كورنيش النيل حتى المعصرة مغطاة بأسطولنا."
      }],
    nearby: ["دار السلام", "المعادي", "صقر قريش", "الأوتوستراد", "المقطم", "السيدة عائشة"]
  },

  "دار السلام": {
    tier: 2,
    title: "ونش انقاذ دار السلام",
    metaDescription: "ونش انقاذ دار السلام: كورنيش النيل، محطة مترو دار السلام، شارع الفيوم، كوبري دار السلام. وصول 10-15 دقيقة - 01044844492.",
    intro: "خدمة ونش إنقاذ سريعة واقتصادية في دار السلام وجنوب القاهرة، تشمل كورنيش النيل وشارع الفيوم ومحيط محطة مترو دار السلام والزهراء ومستشفى مبرة المعادي.",
    responseTime: "10–15 دقيقة في دار السلام",
    landmarks: ["محطة مترو دار السلام", "مستشفى مبرة المعادي", "كوبري دار السلام العلوي", "موقف ميكروباص دار السلام الكورنيش"],
    streets: ["كورنيش النيل دار السلام", "شارع الفيوم", "شارع الفتح", "شارع 9 دار السلام", "طريق مصر حلوان الزراعي"],
    localNotes: ["تمركز مباشر على كورنيش النيل للوصول السريع دون التعطل في الشوارع الداخلية.", "خدمات طوارئ فورية لشحن البطاريات وتغيير الإطارات والسحب الآمن."],
    faqs: [
      {
            "q": "هل يتوفر ونش إنقاذ على كورنيش النيل قطاع دار السلام؟",
            "a": "نعم، أوناشنا متمركزة على الكورنيش بين المعادي ودار السلام ومصر القديمة على مدار 24 ساعة."
      }
,
      {
        "q": "ما زمن الوصول من دار السلام إلى المعادي أو حلوان؟",
        "a": "دار السلام بين المعادي وحلوان — وصولنا في 10-15 دقيقة لأي موقع داخل الحي."
      }],
    nearby: ["المعادي", "البساتين", "مصر القديمة", "المنيل", "السيدة زينب"]
  },

  "طرة": {
    tier: 2,
    title: "ونش انقاذ طرة",
    metaDescription: "ونش انقاذ طرة: طرة البلد، طرة الأسمنت، كورنيش النيل، محطة مترو طرة، الأوتوستراد. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "نغطي منطقة طرة بالكامل (طرة البلد، طرة الأسمنت، وطرة الحجارة) على كورنيش النيل والأوتوستراد بأحدث أوناش سحب سيارات مجهزة لخدمة الملاكي والنقل.",
    responseTime: "10–15 دقيقة في طرة",
    landmarks: ["محطة مترو طرة البلد", "محطة مترو كوتسيكا", "مصانع أسمنت طرة", "ميدان طرة على الكورنيش"],
    streets: ["طريق كورنيش النيل طرة", "طريق مصر حلوان الزراعي", "طريق الأوتوستراد طرة", "شارع معهد الأمناء"],
    localNotes: ["أوناش قريبة من كوبري شمال طرة الجديد لسرعة الانتقال بين الكورنيش والأوتوستراد.", "توفير خدمات سحب المعدات وسيارات النقل وسيارات الملاكي."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ إلى طرة الأسمنت أو كوتسيكا؟",
            "a": "يصلك الونش خلال 10 إلى 15 دقيقة بحد أقصى."
      }
,
      {
        "q": "هل تخدمون منطقة طرة الصناعية والإسمنت؟",
        "a": "نعم، طرة الإسمنت والمنطقة الصناعية وشارع طرة كاملاً على النيل مغطاة بخدمتنا 24 ساعة."
      }],
    nearby: ["المعادي", "كوتسيكا", "المعصرة", "حلوان", "الأوتوستراد"]
  },

  "كوتسيكا": {
    tier: 2,
    title: "ونش انقاذ كوتسيكا",
    metaDescription: "ونش انقاذ كوتسيكا: كورنيش النيل، محطة مترو كوتسيكا، طريق حلوان الزراعي. وصول 10-15 دقيقة خدمة 24 ساعة - 01044844492.",
    intro: "خدمة ونش إنقاذ سيارات متواجدة على مدار 24 ساعة في كوتسيكا بين المعادي وطرة، نغطي الكورنيش ومحطة المترو والمناطق السكنية المجاورة بأسرع وقت وأرخص سعر.",
    responseTime: "10–15 دقيقة في كوتسيكا",
    landmarks: ["محطة مترو كوتسيكا", "كوبري كوتسيكا على الكورنيش", "مستشفى كوتسيكا المركزي", "معهد بحوث المياه"],
    streets: ["طريق كورنيش النيل", "شارع كوتسيكا العمومي", "طريق مصر حلوان الزراعي", "شارع النادي"],
    localNotes: ["تمركز عند مخرج كوبري كوتسيكا للتحرك الفوري نحو المعادي أو طرة.", "إصلاح الأعطال الخفيفة في الموقع (بطارية، بنزين، إطارات)."],
    faqs: [
      {
            "q": "هل تخدمون منطقة كوتسيكا على مدار 24 ساعة؟",
            "a": "نعم، الخدمة متاحة طوال اليوم 24/7 دون انقطاع."
      }
,
      {
        "q": "هل تخدمون المنطقة السكنية في كوتسيكا بالقرب من حلوان؟",
        "a": "نعم، كوتسيكا وعين حلوان والمعصرة مغطاة ضمن خدمتنا في منطقة جنوب القاهرة."
      }],
    nearby: ["المعادي", "طرة", "المعصرة", "دار السلام", "الأوتوستراد"]
  },

  "مدينة نصر": {
    tier: 1,
    title: "ونش انقاذ مدينة نصر",
    metaDescription: "ونش انقاذ مدينة نصر: عباس العقاد، مكرم عبيد، مصطفى النحاس، سيتي ستارز، الحي العاشر، الطيران، النصر. وصول 7-10 دقائق خدمة 24/7 بخصم 50% - اتصل 01044844492.",
    intro: "مدينة نصر من المراكز الرئيسية لانتشار أوناش ونش إنقاذ محمد بحر؛ نقاط تمركز استراتيجية على مدار الساعة بشوارع مكرم عبيد، عباس العقاد، مصطفى النحاس، طريق النصر، ومحور المشير للوصول إليك في غضون 7 إلى 10 دقائق فقط بأفضل تسعيرة وأحدث سطحات هيدروليكية.",
    responseTime: "7–10 دقائق في مدينة نصر",
    dispatchPoints: [
      "شارع مكرم عبيد وتقاطع طريق النصر أمام سيتي سنتر (الاستجابة: 6–8 دقائق)",
      "ميدان الساعة وشارع عباس العقاد التجاري (الاستجابة: 7–9 دقائق)",
      "شارع مصطفى النحاس ومحيط حديقة الطفل والحي السابع (الاستجابة: 8–10 دقائق)",
      "الحي العاشر ومحور المشير طنطاوي ومحور شينزو آبي (الاستجابة: 9–12 دقيقة)"
    ],
    landmarks: [
      "مقر الشركة (42 ش مكرم عبيد)",
      "سيتي ستارز مول City Stars",
      "شارع عباس العقاد التجاري",
      "شارع مصطفى النحاس الحي الثامن",
      "ستاد القاهرة الدولي وشارع الفنجري",
      "حديقة الطفل وشارع يوسف عباس",
      "سراج مول الحي الثامن",
      "مستشفى التأمين الصحي ومستشفى دار الفؤاد",
      "ميدان رابعة العدوية (الشهيد هشام بركات)",
      "ميدان الساعة وأول طريق النصر"
    ],
    streets: [
      "شارع عباس العقاد",
      "شارع مكرم عبيد",
      "شارع مصطفى النحاس",
      "طريق النصر (الأوتوستراد)",
      "شارع الطيران",
      "شارع يوسف عباس",
      "محور المشير طنطاوي",
      "محور شينزو آبي",
      "شارع الدكتور أحمد الزمر",
      "شارع حسن المأمون"
    ],
    localNotes: [
      "أوناش سحب وسطحات مرنة مخصصة للمناورة السريعة في شوارع مدينة نصر المزدحمة والتعامل مع ركنات الصف الثاني والشارع الضيق.",
      "إخلاء فوري لحالات الأعطال والحوادث أعلى كباري مدينة نصر ومحيط سيتي ستارز لتفادي تعطل حركة السير وتجنب المخالفات المرورية.",
      "قرب المسافة من مجمع ورش الحرفيين والحي العاشر وصقر قريش لنقل سيارات الأعطال الميكانيكية المعقدة وتوكيلات الصيانة المعتمدة بأقل تكلفة.",
      "تجهيزات خاصة لإنقاذ السيارات الأوتوماتيكية وسيارات الهايبرد بحوامل عجل تمنع احتكاك الفتيس أثناء التحميل."
    ],
    faqs: [
      {
        "q": "كم يستغرق ونش الإنقاذ للوصول إلى شارع عباس العقاد أو مكرم عبيد؟",
        "a": "يصلك الونش في أقل من 7 إلى 10 دقائق لتواجد تمركزاتنا الدائمة بشارع مكرم عبيد وتقاطع عباس العقاد مع طريق النصر."
      },
      {
        "q": "ماذا أفعل لو تعطلت سيارتي أعلى كوبري بمدينة نصر أو بمحيط سيتي ستارز؟",
        "a": "قم بتشغيل الفلاشر فوراً والوقوف في أقصى اليمين، ثم اتصل بنا على 01044844492 وسنتحرك فوراً لتأمين مسار السيارة وإخلائها في دقائق تفادياً للزحام."
      },
      {
        "q": "هل تنقلون السيارات المعطلة من مدينة نصر إلى مراكز صيانة الحرفيين أو صقر قريش؟",
        "a": "نعم، نوفر خدمة نقل مباشرة لمراكز الصيانة وتوكيلات غبور والحرفيين وصقر قريش بأسعار ثابتة مخفضة."
      },
      {
        "q": "هل يتوفر لديكم ونش لنقل السيارات من مدينة نصر إلى المحافظات الأخرى؟",
        "a": "نعم، نوفر سطحات هيدروليكية مجهزة للسفر لنقل السيارات من مدينة نصر إلى الإسكندرية والساحل الشمالي والعين السخنة وكافة محافظات الجمهورية."
      },
      {
        "q": "هل تقدمون خدمات شحن البطارية وتغيير الإطارات في مدينة نصر؟",
        "a": "نعم، نقدم خدمات المساعدة على الطريق وتشغيل البطارية في الموقع أو تبديل الإطار التالف خلال دقائق دون الحاجة لسحب السيارة."
      }
    ],
    nearby: ["عباس العقاد", "مكرم عبيد", "مصطفى النحاس", "الحي العاشر", "مصر الجديدة", "التجمع الخامس", "الأوتوستراد"]
  },

  "عباس العقاد": {
    tier: 2,
    title: "ونش انقاذ شارع عباس العقاد مدينة نصر",
    metaDescription: "ونش انقاذ عباس العقاد: من ميدان الساعة حتى حديقة الطفل وتقاطع مصطفى النحاس وطريق النصر. وصول 5-10 دقائق خدمة 24 ساعة - 01044844492.",
    intro: "نوفر أوناش إنقاذ متمركزة في شارع عباس العقاد الشهير بمدينة نصر لخدمة المحلات التجارية والشركات ومواقف السيارات وحالات الطوارئ والأعطال طوال الـ 24 ساعة.",
    responseTime: "5–10 دقائق في عباس العقاد",
    landmarks: ["ميدان الساعة عباس العقاد", "حديقة الطفل", "جنينة مول Genena Mall", "تقاطع مصطفى النحاس مع عباس العقاد", "مجمع البنوك بعباس العقاد"],
    streets: ["شارع عباس العقاد الرئيسي", "شارع البطراوي", "شارع أحمد فخري", "شارع إبراهيم نوار", "شارع حسنين هيكل"],
    localNotes: ["أوناش مدمجة تتفادى الزحام التجاري وتصل للعميل في دقائق معدودة.", "جاهزية كاملة لنقل السيارات المتعطلة في جراجات جنينة مول والمراكز الطبية."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند جنينة مول أو ميدان الساعة بعباس العقاد؟",
            "a": "نعم، أوناشنا متواجدة بالقرب من ميدان الساعة وتصل في غضون 5 إلى 10 دقائق."
      }
,
      {
        "q": "هل تغطون الحوادث داخل مول سيتي ستارز وجراجاته متعددة الطوابق؟",
        "a": "نعم، لدينا خبرة واسعة في سحب السيارات من جراجات سيتي ستارز بأوناش مدمجة تدخل الجراجات المتعددة."
      }],
    nearby: ["مدينة نصر", "مكرم عبيد", "مصطفى النحاس", "شارع الطيران", "الحي السابع"]
  },

  "مكرم عبيد": {
    tier: 2,
    title: "ونش انقاذ شارع مكرم عبيد مدينة نصر",
    metaDescription: "ونش انقاذ مكرم عبيد: سيتي ستارز، حديقة العاشر، السراج مول، تقاطع طريق النصر. أسرع ونش في 5-10 دقائق من فرعنا 42 ش مكرم عبيد - 01044844492.",
    intro: "شارع مكرم عبيد يضم فرعنا الرئيسي (42 ش مكرم عبيد). نوفر أسرع خدمة إنقاذ سيارات في مدينة نصر مع تغطية محيط سيتي ستارز وسراج مول وميدان مكرم عبيد وحديقة العاشر.",
    responseTime: "5–10 دقائق في مكرم عبيد",
    landmarks: ["فرع الشركة (42 ش مكرم عبيد)", "سيتي ستارز مول", "حديقة العاشر من رمضان", "السراج مول", "ميدان مكرم عبيد مع مصطفى النحاس"],
    streets: ["شارع مكرم عبيد", "شارع عبد الرازق السنهوري", "شارع سيبويه المصري", "طريق النصر", "شارع أحمد قاسم جودة"],
    localNotes: ["انطلاق فوري من مقر الشركة في 42 مكرم عبيد لأي نقطة في الشارع والشوارع المتفرعة.", "توفير وصلات بطارية وتزويد وقود وسحب سيارات حوادث بأحدث المعدات."],
    faqs: [
      {
            "q": "أين يقع فرعكم في شارع مكرم عبيد؟",
            "a": "مقرنا في 42 ش مكرم عبيد، مدينة نصر، وأوناشنا متواجدة على مدار 24 ساعة."
      }
,
      {
        "q": "هل تخدمون التجمعات السكنية والأبراج الجديدة على امتداد مكرم عبيد؟",
        "a": "نعم، شارع مكرم عبيد كاملاً من الشعلة حتى مصطفى النحاس والأبراج الجانبية مغطاة 24/7."
      }],
    nearby: ["مدينة نصر", "عباس العقاد", "سيتي ستارز", "مصطفى النحاس", "الحي السادس", "الحي الثامن"]
  },

  "مصطفى النحاس": {
    tier: 2,
    title: "ونش انقاذ شارع مصطفى النحاس مدينة نصر",
    metaDescription: "ونش انقاذ مصطفى النحاس: من امتداد رمسيس حتى الحي العاشر والمنهل والوفاء والأمل. وصول 10 دقائق خدمة 24 ساعة - 01044844492.",
    intro: "شارع مصطفى النحاس المحور الطولي الأكبر في مدينة نصر. أوناشنا متمركزة على طول الشارع عند تقاطعات مكرم عبيد وعباس العقاد والطيران والمنهل لتغطية سريعة وشاملة.",
    responseTime: "10 دقائق في مصطفى النحاس",
    landmarks: ["ميدان المنهل", "مدرسة المنهل الخاصة", "تقاطع مصطفى النحاس مع الطيران", "تقاطع مصطفى النحاس مع عباس العقاد", "محيط الوفاء والأمل"],
    streets: ["شارع مصطفى النحاس الرئيسي", "شارع الطيران", "شارع زاكر حسين", "شارع يوسف عباس", "شارع حسنين هيكل"],
    localNotes: ["تأمين فوري لمسار السيارات على جانبي خط الترام القديم ومسارات مصطفى النحاس.", "سحب آمن وسريع للمركبات المتعطلة في محيط مجمع المدارس والمستشفيات."],
    faqs: [
      {
            "q": "كم يستغرق وصول الونش عند ميدان المنهل بمصطفى النحاس؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتواجد سياراتنا الدائم على المحور."
      }
,
      {
        "q": "هل تخدمون طريق النصر المتقاطع مع مصطفى النحاس؟",
        "a": "نعم، تقاطع مصطفى النحاس مع طريق النصر وشارع الطيران يُغطى بأسطولنا 24 ساعة."
      }],
    nearby: ["مدينة نصر", "الحي العاشر", "الحي السابع", "الحي الثامن", "مكرم عبيد", "عباس العقاد"]
  },

  "شارع النصر": {
    tier: 2,
    title: "ونش انقاذ طريق النصر مدينة نصر",
    metaDescription: "ونش انقاذ طريق النصر: النادي الأهلي، المنصة، ستاد القاهرة، كوبري الفنجري، سيتي سنتر ألماظة. وصول 10 دقائق خدمة 24/7 - 01044844492.",
    intro: "طريق النصر يربط بين مصر الجديدة والعباسية ومدينة نصر والمعادي. أوناش إنقاذ محمد بحر متمركزة عند النادي الأهلي والمنصة وكوبري الفنجري للتدخل السريع على مدار 24 ساعة.",
    responseTime: "10 دقائق على طريق النصر",
    landmarks: ["النادي الأهلي بمدينة نصر", "نصب الجندي المجهول (المنصة)", "ستاد القاهرة الدولي", "صالة حسن مصطفى", "كوبري الفنجري", "سيتي سنتر ألماظة"],
    streets: ["طريق النصر (الأوتوستراد)", "شارع يوسف عباس", "شارع خضر التوني", "محور المشير", "امتداد رمسيس"],
    localNotes: ["تأمين الحوادث والأعطال السريعة على طريق النصر بأقماع وإشارات ليلية.", "سحب ونقل سيارات الفعاليات والمباريات من محيط ستاد القاهرة والنادي الأهلي."],
    faqs: [
      {
            "q": "هل تغطون محيط النادي الأهلي وستاد القاهرة على طريق النصر؟",
            "a": "نعم، نغطي قطاع النادي الأهلي وستاد القاهرة والمنصة بالكامل على مدار الساعة."
      }
,
      {
        "q": "ما أسرع طريق لوصول الونش في شارع النصر وقت الذروة؟",
        "a": "نستخدم طرق فرعية موازية لتجنب الزحام على شارع النصر — وصولنا في 10-15 دقيقة حتى في الذروة."
      }],
    nearby: ["مدينة نصر", "مصر الجديدة", "ألماظة", "العباسية", "المشير", "الأوتوستراد"]
  },

  "الحي العاشر": {
    tier: 2,
    title: "ونش انقاذ الحي العاشر مدينة نصر",
    metaDescription: "ونش انقاذ الحي العاشر مدينة نصر: موقف العاشر، شارع أحمد الزمر، سوق السيارات القديم، محور الوفاء والأمل. وصول 10 دقائق - 01044844492.",
    intro: "تغطية كاملة لإنقاذ السيارات في الحي العاشر بمدينة نصر، نخدم منطقة موقف العاشر، شارع أحمد الزمر، زهراء مدينة نصر، والمحاور المؤدية للتجمع الخامس والدائري.",
    responseTime: "10 دقائق في الحي العاشر",
    landmarks: ["موقف الحي العاشر الرئيسي", "شارع أحمد الزمر", "سوق السيارات القديم", "مجمع مدارس العاشر", "محور الوفاء والأمل"],
    streets: ["شارع أحمد الزمر", "شارع زاكر حسين", "محور شينزو آبي", "شارع الميثاق", "محور الشهيد"],
    localNotes: ["تمركز بالقرب من مخرج شينزو آبي ومحور الوفاء والأمل لسرعة الحركة.", "جاهزية لنقل سيارات الملاكي والميكروباص والسيارات التجارية."],
    faqs: [
      {
            "q": "هل ونش الإنقاذ متاح في موقف الحي العاشر وزهراء مدينة نصر؟",
            "a": "نعم، لدينا ونش متمركز في الحي العاشر لخدمة المنطقة بالكامل في 10 دقائق."
      }
,
      {
        "q": "هل تغطون جميع الأحياء من السادس حتى العاشر في مدينة نصر؟",
        "a": "نعم، جميع أحياء مدينة نصر من الأول حتى العاشر مغطاة بخدمتنا الكاملة 24 ساعة."
      }],
    nearby: ["مدينة نصر", "زهراء مدينة نصر", "التجمع الخامس", "محور شينزو آبي", "الحي السابع"]
  },

  "الحي السابع": {
    tier: 2,
    title: "ونش انقاذ الحي السابع مدينة نصر",
    metaDescription: "ونش انقاذ الحي السابع مدينة نصر: عمارات العبور، شارع الطيران، مستشفى الشرطة، مجمع المحاكم، مستشفى تبارك. وصول 10 دقائق - 01044844492.",
    intro: "نوفر خدمة ونش إنقاذ وسحب سيارات موثوقة في الحي السابع بمدينة نصر، تشمل محيط مستشفى الشرطة، شارع الطيران، عمارات عثمان، ومحكمة مدينة نصر على مدار 24 ساعة.",
    responseTime: "10 دقائق في الحي السابع",
    landmarks: ["مستشفى الشرطة بمدينة نصر", "محكمة مدينة نصر", "شارع الطيران بالحي السابع", "عمارات العبور وعثمان", "مستشفى تبارك للأطفال"],
    streets: ["شارع الطيران", "شارع يوسف عباس", "شارع ذاكر حسين", "شارع الخليفة الظافر", "شارع عبد الله العربي"],
    localNotes: ["أوناش متواجدة بالقرب من مستشفى الشرطة لخدمة الحالات الطارئة وأعطال المرضى والزوار.", "سرعة التحرك نحو الحي السادس والحي الثامن وطريق النصر."],
    faqs: [
      {
            "q": "كم يستغرق وصول الونش لمستشفى الشرطة بالحي السابع؟",
            "a": "يصل الونش خلال أقل من 10 دقائق من نقطة تمركزنا بشارع الطيران."
      }
,
      {
        "q": "هل تخدمون المناطق الداخلية في الحي السابع بمدينة نصر؟",
        "a": "نعم، الشوارع الداخلية والتجارية في الحي السابع مغطاة — وصولنا بالشوارع الفرعية يتفادى الزحام."
      }],
    nearby: ["مدينة نصر", "الحي السادس", "الحي العاشر", "عباس العقاد", "شارع الطيران"]
  },

  "الحي السادس": {
    tier: 2,
    title: "ونش انقاذ الحي السادس مدينة نصر",
    metaDescription: "ونش انقاذ الحي السادس مدينة نصر: ميدان الساعة، شارع الخليفة القاهر، المدينة الجامعية للأزهر، مستشفى التأمين الصحي. وصول 10 دقائق - 01044844492.",
    intro: "خدمة إنقاذ وسحب سيارات سريعة بالحي السادس في مدينة نصر، نغطي محيط جامعة الأزهر، مستشفى التأمين الصحي، شارع الخليفة القاهر، وميدان الساعة بأرخص الأسعار.",
    responseTime: "10 دقائق في الحي السادس",
    landmarks: ["المدينة الجامعية لجامعة الأزهر", "مستشفى التأمين الصحي بالحي السادس", "ميدان الساعة", "نادي السكة الحديد (بالقرب)"],
    streets: ["شارع الخليفة القاهر", "شارع بستان الدكة", "شارع الطيران (مدخل السادس)", "شارع إسماعيل الفنجري"],
    localNotes: ["تغطية خاصة لسيارات الطلاب والموظفين في محيط جامعة الأزهر ومستشفى التأمين الصحي.", "أوناش مدمجة سهلة الحركة في المربعات السكنية والشوارع الهادئة."],
    faqs: [
      {
            "q": "هل تخدمون مستشفى التأمين الصحي بالحي السادس؟",
            "a": "نعم، نصل في دقائق معدودة لنقل وسحب أي سيارة متعطلة أمام المستشفى."
      }
,
      {
        "q": "ما هي أبرز المعالم التي تتمركز أوناشكم بالقرب منها في الحي السادس؟",
        "a": "نتمركز بالقرب من مصطفى النحاس وشارع عمر بن الخطاب وحديقة العاشر في الحي السادس."
      }],
    nearby: ["مدينة نصر", "الحي السابع", "طريق النصر", "العباسية", "عباس العقاد"]
  },

  "الحي الأول": {
    tier: 2,
    title: "ونش انقاذ الحي الأول مدينة نصر",
    metaDescription: "ونش انقاذ الحي الأول مدينة نصر: شارع خضر التوني، يوسف عباس، محطة مترو الاستاد، النادي الأهلي. وصول 10 دقائق خدمة 24 ساعة - 01044844492.",
    intro: "تغطية فورية للحي الأول بمدينة نصر، نخدم محيط محطة مترو الاستاد، شارع يوسف عباس، شارع خضر التوني، ومحيط النادي الأهلي بأحدث أوناش السحب المجهزة.",
    responseTime: "10 دقائق في الحي الأول",
    landmarks: ["محطة مترو الاستاد", "شارع يوسف عباس", "فندق توليب الجلاء", "مجمع الصالات المغطاة", "بانوراما حرب أكتوبر (بالقرب)"],
    streets: ["شارع يوسف عباس", "شارع خضر التوني", "شارع عبد الله بن طاهر", "طريق النصر", "شارع الطيران"],
    localNotes: ["موقع استراتيجي يتيح الانطلاق السريع نحو مصر الجديدة أو العباسية أو الأوتوستراد.", "توفير خدمات سحب فورية ورفع آمن للسيارات الرياضية والملاكي."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند محطة مترو الاستاد بالحي الأول؟",
            "a": "نعم، أوناشنا متمركزة بشارع يوسف عباس ومحطة الاستاد على مدار الساعة."
      }
,
      {
        "q": "هل تخدمون الحي الأول في مدينة نصر وشارع تحمد الله؟",
        "a": "نعم، الحي الأول في مدينة نصر والشوارع الداخلية المحيطة به مغطاة بشكل كامل."
      }],
    nearby: ["مدينة نصر", "مصر الجديدة", "الحي السادس", "العباسية", "طريق النصر"]
  },

  "زهراء مدينة نصر": {
    tier: 2,
    title: "ونش انقاذ زهراء مدينة نصر",
    metaDescription: "ونش انقاذ زهراء مدينة نصر: صن سيتي، الميثاق، عمارات الضباط، محور شينزو آبي، مجمع المحاكم. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "خدمة ونش إنقاذ سيارات متخصصة في زهراء مدينة نصر، نغطي شارع الميثاق، مساكن الضباط، محور شينزو آبي، ومداخل الطريق الدائري والتجمع الخامس بسرعة فائقة.",
    responseTime: "10–15 دقيقة في زهراء مدينة نصر",
    landmarks: ["شارع الميثاق الرئيسي", "مساكن ضباط القوات المسلحة بالزهراء", "محور شينزو آبي", "مجمع محاكم زهراء مدينة نصر", "محطة بنزين وطنية بالزهراء"],
    streets: ["شارع الميثاق", "محور شينزو آبي", "شارع اللواء حسام خليل", "محور الشهيد", "طريق زهراء مدينة نصر - التجمع"],
    localNotes: ["أوناش متواجدة عند مطلع محور شينزو آبي لخدمة سريعة للمنطقة والمحاور الرابطة مع التجمع.", "سحب آمن وسريع للمركبات المتعطلة في الشوارع الداخلية والمواقف السكنية."],
    faqs: [
      {
            "q": "هل تغطون شارع الميثاق ومحور شينزو آبي بزهراء مدينة نصر؟",
            "a": "نعم، التغطية تشمل شارع الميثاق وشينزو آبي ومداخل الدائري بالكامل."
      }
,
      {
        "q": "ما الفرق في خدمة زهراء مدينة نصر عن باقي أحياء مدينة نصر؟",
        "a": "زهراء مدينة نصر يُغطى بنفس أسطول مدينة نصر — وصولنا 10-15 دقيقة مع تغطية كل الكمبوندات والعمارات."
      }],
    nearby: ["مدينة نصر", "الحي العاشر", "التجمع الخامس", "محور شينزو آبي", "طريق المشير"]
  },

  "طريق المشير": {
    tier: 3,
    title: "ونش انقاذ محور المشير طنطاوي",
    metaDescription: "ونش انقاذ محور المشير طنطاوي: مركز مصر للمعارض EIEC، فندق تريومف، مطلع الدائري، مسجد المشير. وصول 10 دقائق خدمة 24 ساعة - 01044844492.",
    intro: "محور المشير طنطاوي من أهم المحاور الاستراتيجية في شرق القاهرة الرابطة بين مدينة نصر والتجمع الخامس. نوفر أوناش إنقاذ متمركزة عند مركز المنارة ومسجد المشير لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10 دقائق على محور المشير",
    landmarks: ["مركز مصر للمعارض والمؤتمرات الدولية EIEC", "مركز المنارة للمؤتمرات", "مسجد المشير طنطاوي", "فندق تريومف التجمع", "ميدان الواحة"],
    streets: ["محور المشير طنطاوي", "محور الشهيد", "طريق الواحة", "مطلع الطريق الدائري", "شارع امتداد رمسيس"],
    localNotes: ["تأمين سريع للسيارات المتعطلة خلال فعاليات ومعارض مركز مصر للمعارض والمنارة.", "أوناش مجهزة للتعامل مع السرعات العالية على المحور وتأمين موقع الحادث."],
    faqs: [
      {
            "q": "هل توفرون ونش عند مركز المنارة ومعارض المشير طنطاوي؟",
            "a": "نعم، لدينا أوناش متمركزة بصفة مستمرة على محور المشير طنطاوي أمام مركز المعارض."
      }
,
      {
        "q": "هل يختلف زمن الوصول على محور المشير عن طريق النصر؟",
        "a": "المحور والطريق متوازيان — نختار الأسرع حسب الزحام. متوسط وصولنا 10-20 دقيقة على كليهما."
      }],
    nearby: ["مدينة نصر", "التجمع الخامس", "الأوتوستراد", "محور جيهان السادات", "الدائري"]
  },

  "محور جيهان السادات": {
    tier: 3,
    title: "ونش انقاذ محور جيهان السادات (محور الفردوس)",
    metaDescription: "ونش انقاذ محور جيهان السادات (الفردوس): من وسط البلد وصلاح سالم حتى مدينة نصر والمشير. وصول 10 دقائق بخصم 50% - 01044844492.",
    intro: "محور جيهان السادات (محور الفردوس سابقاً) شريان حر يربط وسط البلد وقلعة صلاح الدين بمدينة نصر والتجمع. أوناشنا متمركزة على المحور لتوفير إنقاذ سريع وسحب آمن للمركبات.",
    responseTime: "10 دقائق على محور جيهان السادات",
    landmarks: ["تقاطع صلاح سالم مع الفردوس", "مقابر المماليك التاريخية", "كوبري جيهان السادات العلوي", "مطلع محور المشير من الفردوس"],
    streets: ["محور جيهان السادات الحر", "طريق صلاح سالم", "شارع أحمد سعيد", "محور الشهيد", "امتداد رمسيس"],
    localNotes: ["أوناش حديثة وسريعة للتحرك على المسار الحر بدون إعاقة للحركة المرورية.", "توفير خدمات سحب فورية للسيارات الملاكي ونقلها لأي موقع في القاهرة."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ على محور جيهان السادات الحر؟",
            "a": "يصل الونش في غضون 10 دقائق من أقرب نقطة تمركز عند صلاح سالم أو المشير."
      }
,
      {
        "q": "هل تغطون محور جيهان السادات من الدائري حتى التجمع؟",
        "a": "نعم، محور جيهان كاملاً من نقطة التقاطع مع الدائري حتى التجمع الخامس مغطى بأوناشنا 24 ساعة."
      }],
    nearby: ["مدينة نصر", "وسط البلد", "صلاح سالم", "طريق المشير", "القلعة", "المقطم"]
  },

  "التجمع الخامس مدينة نصر": {
    tier: 1,
    title: "ونش انقاذ ونقل سيارات التجمع الخامس مدينة نصر",
    metaDescription: "ونش انقاذ ونقل سيارات بين التجمع الخامس ومدينة نصر: محور المشير، محور الشهيد، الواحة، كوبري الدائري. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "المسار الرابط بين التجمع الخامس ومدينة نصر (عبر محاور المشير طنطاوي، الشهيد، محور شينزو آبي، وطريق الواحة) يعتبر من أكثر الشرايين المرورية حيوية وتنقلاً في القاهرة. نوفر أسطول أوناش إنقاذ متأهباً لنقل وسحب السيارات المعطلة والحوادث بين التجمع ومدينة نصر، ونقل السيارات لكمبوندات التجمع أو مراكز الصيانة بالحي السابع والعاشر وعباس العقاد بخصم 50%.",
    responseTime: "10–15 دقيقة على مسار التجمع الخامس ومدينة نصر",
    landmarks: [
      "محور المشير طنطاوي (NA)",
      "محور الشهيد ومحور شينزو آبي",
      "كوبري الواحة ومطلع الدائري",
      "كايرو فيستيفال سيتي مول",
      "مسجد المشير طنطاوي ومركز المنارة",
      "الحي العاشر وزهراء مدينة نصر",
      "أكاديمية الشرطة والداون تاون مول",
      "ميدان الساعة والنادي الأهلي بمدينة نصر"
    ],
    streets: [
      "محور المشير طنطاوي",
      "محور الشهيد",
      "طريق الواحة",
      "شارع التسعين الجنوبي والشمالي",
      "محور عباس العقاد الممتد",
      "شارع امتداد رمسيس",
      "الطريق الدائري (قطاع التجمع - مدينة نصر)"
    ],
    localNotes: [
      "تمركز دائم عند كوبري الواحة ومحور المشير للوصول الفوري خلال دقائق لأي نقطة بين التجمع الخامس ومدينة نصر.",
      "خدمة نقل يومية احترافية للسيارات الملاكي والكهربائية (EVs) من كمبوندات التجمع لمراكز التوكيلات والورش بمدينة نصر.",
      "تأمين كامل على المحاور السريعة باستخدام أحدث أوناش السطحة الهيدروليكية كاملة النزول لحماية ممتلكاتك."
    ],
    faqs: [
      {
        "q": "كم يستغرق نقل سيارة معطلة من التجمع الخامس إلى مدينة نصر؟",
        "a": "يصل الونش إليك خلال 10-15 دقيقة، وتستغرق عملية النقل بين التجمع ومدينة نصر حوالي 15-20 دقيقة حسب حركة المرور عبر محور المشير أو الشهيد."
      },
      {
        "q": "هل توفرون ونش سطحة هيدروليك لنقل السيارات الفارهة بين التجمع ومدينة نصر؟",
        "a": "نعم، كافة أوناشنا من فئة السطحات الهيدروليكية الحديثة المزودة بأنظمة تثبيت رباعية لحماية السيارات الفارهة والحديثة أثناء النقل."
      },
      {
        "q": "عربيتي عطلت على كوبري الواحة أو محور المشير، هل الونش يقدر يوصلني بسرعة؟",
        "a": "نعم، لدينا تمركز مباشر عند مطلع محور المشير وكوبري الواحة للتدخل السريع وإخلاء السيارات المتعطلة ومنع التكدس المروري."
      }
    ],
    nearby: ["التجمع الخامس", "مدينة نصر", "التجمع الأول", "محور المشير", "الحي العاشر", "القطامية", "الطريق الدائري"]
  }
};
